// Socket generation-capacity exposes both shared media and video admission for
// subscription work. Spark admission is shared with all work on the account.
export function getVideoAdmission(capacity, projectConfig, model, balance = {}) {
  const paymentModel = projectConfig.billingMode === 'subscription' ? 'subscription'
    : modelRequiresPremiumSpark(model) || Number(balance.premiumSpark) > 0 ? 'paid_spark' : 'free_spark';
  const scopes = paymentModel === 'subscription' ? ['account_media', 'account_video'] : ['account_all'];
  const limits = scopes.map(scope => capacity?.admission?.find(entry => entry.paymentModel === paymentModel && entry.scope === scope));
  if (limits.some(entry => !entry?.limit || entry.limit.status === 'unavailable')) {
    return { status: 'unavailable', canSubmit: false, paymentModel,
      message: 'Your account video capacity could not be confirmed. Review the remaining videos again when capacity is available.' };
  }
  const remaining = Math.min(...limits.map(entry => entry.limit.status === 'unlimited'
    ? Infinity : Math.max(0, Number(entry.limit.value) - Number(entry.used))));
  return { status: remaining === 0 ? 'full' : 'available', canSubmit: remaining > 0, paymentModel,
    remaining: remaining === Infinity ? null : remaining,
    message: remaining === 0 ? 'Your account video queue is full, including work in other Sogni apps. The remaining videos stay saved without being submitted.' : null };
}
import { modelRequiresPremiumSpark } from './generation-request.js';
